import { render } from "./ModuleCreate.vue?vue&type=template&id=50fa716f&scoped=true"
import script from "./ModuleCreate.vue?vue&type=script&lang=js"
export * from "./ModuleCreate.vue?vue&type=script&lang=js"

import "./ModuleCreate.vue?vue&type=style&index=0&id=50fa716f&scoped=true&lang=css"

import exportComponent from "/var/www/tis-live/frontend/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50fa716f"]])

export default __exports__